import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { from, Observable, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { TokenService } from '../service/token.service';
import { environment } from '../environments/environment';

@Injectable({
    providedIn:'root'
}
)
export class JwtInterceptor implements HttpInterceptor {
    constructor(private tokenService: TokenService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isApiUrl = request.url.startsWith(environment.apiOrigin);

        if (!isApiUrl) {
            return next.handle(request);
        }

        return from(this.tokenService.acquireAccessToken()).pipe(
            switchMap((accessToken) => next.handle(this.withAuthHeaders(request, accessToken))),
            catchError((error) => {
                if (!this.isAuthExpiredResponse(error)) {
                    return throwError(() => error);
                }

                return from(this.tokenService.acquireAccessToken(true)).pipe(
                    switchMap((accessToken) => next.handle(this.withAuthHeaders(request, accessToken))),
                    catchError((retryError) => {
                        if (this.isAuthExpiredResponse(retryError)) {
                            this.tokenService.startInteractiveLogin();
                        }

                        return throwError(() => retryError);
                    })
                );
            })
        );
    }

    private withAuthHeaders(request: HttpRequest<any>, accessToken: string): HttpRequest<any> {
        return request.clone({
            setHeaders: {
                Authorization: `Bearer ${accessToken}`,
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        });
    }

    private isAuthExpiredResponse(error: any): boolean {
        return error instanceof HttpErrorResponse
            && error.status === 401
            && (error.error?.error === 'AUTH_EXPIRED' || error.error?.error === 'AUTH_REQUIRED');
    }
}
